import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DiaryRecords = _resolveComponent("DiaryRecords")!
  const _component_AddDiaryButton = _resolveComponent("AddDiaryButton")!
  const _component_n_layout_sider = _resolveComponent("n-layout-sider")!
  const _component_ContentEditor = _resolveComponent("ContentEditor")!
  const _component_n_tab_pane = _resolveComponent("n-tab-pane")!
  const _component_SQFView = _resolveComponent("SQFView")!
  const _component_n_tabs = _resolveComponent("n-tabs")!
  const _component_n_layout = _resolveComponent("n-layout")!

  return (_openBlock(), _createBlock(_component_n_layout, { "has-sider": "" }, {
    default: _withCtx(() => [
      _createVNode(_component_n_layout_sider, {
        bordered: "",
        height: "100%"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_DiaryRecords),
          _createVNode(_component_AddDiaryButton)
        ]),
        _: 1
      }),
      _createVNode(_component_n_layout, { style: {"margin":"0 1rem"} }, {
        default: _withCtx(() => [
          (_ctx.isCurrentDiary)
            ? (_openBlock(), _createBlock(_component_n_tabs, {
                key: 0,
                animated: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_n_tab_pane, {
                    name: "content",
                    tab: "Editeur"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ContentEditor)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_n_tab_pane, {
                    name: "sqf",
                    tab: "SQF"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_SQFView)
                    ]),
                    _: 1
                  }),
                  (_ctx.unsaved)
                    ? (_openBlock(), _createBlock(_component_n_tab_pane, {
                        key: 0,
                        name: "nsaved",
                        tab: "Modifications non enregistrées",
                        disabled: ""
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}